import React from 'react';
import cx from 'classnames';
import { Button as MuiButton } from '@mui/material';

const Button = ({ variant = 'submit', className = '', classes, ...props }) => {
  return <MuiButton className={cx(className, classes.button, classes[variant])} {...props} />;
};

export default Button;
